import VectorService from "@/services/vector.service";
import CustomControl from "./custom-control";

export default class CenterAllControl extends CustomControl {
    constructor() {
        super(CenterAllControl.buildHtml());
    }

    addEvents(element: HTMLElement): void {
        element.querySelector('button')!.addEventListener('click', () => { VectorService.centerFeaturesByLayer(5) }, false)
    }

    static buildHtml() {
        const element = document.createElement('div')
        element.className = 'ol-control center-all-control'
        const button = document.createElement('button')
        button.innerHTML = `
            <img src="${require('@/assets/img/centrar.png')}">
        `
        element.appendChild(button)
        return element
    }

}